import { render, staticRenderFns } from "./ConfirmArchive.vue?vue&type=template&id=4227493d&"
import script from "./ConfirmArchive.vue?vue&type=script&lang=js&"
export * from "./ConfirmArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports